var _rect, _rect2, _rect3, _rect4, _path, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusBarFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 324,
    height: 12,
    rx: 6,
    fill: "#3E4775"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 1.25,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#B3A4FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 4.25,
    width: 6,
    height: 6,
    rx: 3,
    stroke: "#3E4775",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 1.25,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#E75B55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.282 4.532a.96.96 0 000 1.359l1.359 1.359-1.359 1.36a.96.96 0 101.359 1.358L162 8.61l1.359 1.36a.96.96 0 101.359-1.36l-1.359-1.359 1.359-1.36a.96.96 0 10-1.359-1.358L162 5.89l-1.359-1.36a.96.96 0 00-1.359 0z",
    fill: "#3E4775"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 314.25,
    y: 3.75,
    width: 6,
    height: 6,
    rx: 3,
    stroke: "#CECEEB",
    strokeWidth: 2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzI0IiBoZWlnaHQ9IjE0IiB2aWV3Qm94PSIwIDAgMzI0IDE0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB5PSIwLjc1IiB3aWR0aD0iMzI0IiBoZWlnaHQ9IjEyIiByeD0iNiIgZmlsbD0iIzNFNDc3NSIvPgo8cmVjdCB4PSIwLjI1IiB5PSIxLjI1IiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHJ4PSI2IiBmaWxsPSIjQjNBNEZGIi8+CjxyZWN0IHg9IjMuMjUiIHk9IjQuMjUiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIzIiBzdHJva2U9IiMzRTQ3NzUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cmVjdCB4PSIxNTYiIHk9IjEuMjUiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgcng9IjYiIGZpbGw9IiNFNzVCNTUiLz4KPHBhdGggZD0iTTE1OS4yODIgNC41MzE1MkMxNTguOTA2IDQuOTA2ODYgMTU4LjkwNiA1LjUxNTQgMTU5LjI4MiA1Ljg5MDc2TDE2MC42NDEgNy4yNUwxNTkuMjgyIDguNjA5MjRDMTU4LjkwNiA4Ljk4NDU5IDE1OC45MDYgOS41OTMxMiAxNTkuMjgyIDkuOTY4NDhDMTU5LjY1NyAxMC4zNDM4IDE2MC4yNjUgMTAuMzQzOCAxNjAuNjQxIDkuOTY4NDhMMTYyIDguNjA5MjRMMTYzLjM1OSA5Ljk2ODQ4QzE2My43MzUgMTAuMzQzOCAxNjQuMzQzIDEwLjM0MzggMTY0LjcxOCA5Ljk2ODQ4QzE2NS4wOTQgOS41OTMxMyAxNjUuMDk0IDguOTg0NiAxNjQuNzE4IDguNjA5MjRMMTYzLjM1OSA3LjI1TDE2NC43MTggNS44OTA3NkMxNjUuMDk0IDUuNTE1NDEgMTY1LjA5NCA0LjkwNjg4IDE2NC43MTggNC41MzE1MkMxNjQuMzQzIDQuMTU2MTYgMTYzLjczNSA0LjE1NjE3IDE2My4zNTkgNC41MzE1MkwxNjIgNS44OTA3NkwxNjAuNjQxIDQuNTMxNTJDMTYwLjI2NSA0LjE1NjE2IDE1OS42NTcgNC4xNTYxNyAxNTkuMjgyIDQuNTMxNTJaIiBmaWxsPSIjM0U0Nzc1Ii8+CjxyZWN0IHg9IjMxNC4yNSIgeT0iMy43NSIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjMiIHN0cm9rZT0iI0NFQ0VFQiIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";
export { SvgStatusBarFailed as ReactComponent };